// extracted by mini-css-extract-plugin
export default {"legend":"Questionaires_legend__DkwQv"};